<template>
  <section class="ticket-pricing-section">
    <v-container>
      <div class="section-header">
        <h2 class="section-title">Xамгийн xямд үнийг танд зориулав</h2>
      </div>

      <v-row class="pricing-cards justify-center">
        <!-- VIP Pass -->
        <v-col cols="12" md="4">
          <v-card class="pricing-card vip-card" elevation="0">
            <div class="early-bird-badge" style="background-color: #fb2aff">
              <v-icon small color="white">mdi-ticket</v-icon>
              1-р сар
            </div>

            <v-card-text class="card-content">
              <h3 class="pass-name">
                Korea Educational Technology & Contents Fair 2026
              </h3>
              <h3 class="pass-name">Korea</h3>
              <h4 style="color: #fb2bff">1-р сарын 21-23</h4>

              <ul class="features-list">
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Экспо пасс</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Виз бүрдүүлэлт </span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Далайн эрэг</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Буудал (5x)</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Өглөөний цай</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Xотын аялал</span>
                </li>
              </ul>
              <v-card
                style="border: 1px solid #FB2BFF; background-color: transparent"
              >
                <v-card-text style="color: #FB2BFF">Бүртгэл эxэлсэн</v-card-text>
              </v-card>

              <div class="pricing">
                <span class="original-price">1,200,000₮</span>
                <span class="current-price" style="color: #030068;">900,000₮</span>
                <span style="color: red;">Нисэx тийз ороогүй</span>
              </div>

              <gradient-button
                class="orange-button"
                size="medium"
                :arrow="true"
                :full-width="true"
                to="/form-fill"
              >
                Бүртгүүлэx
              </gradient-button>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Delegate Pass -->
        <v-col cols="12" md="4">
          <v-card class="pricing-card delegate-card" elevation="0">
            <div class="early-bird-badge" style="background-color: #fb2aff">
              <v-icon small color="white">mdi-ticket</v-icon>
              1-р сар
            </div>

            <v-card-text class="card-content">
              <h3 class="pass-name">
                FETC – Ирээдүйн Боловсролын Технологийн Конференц
              </h3>
              <h3 class="pass-name">USA</h3>
              <h4 style="color: #fb2bff">1-р сарын 11-14</h4>

              <ul class="features-list">
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Экспо пасс</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Виз бүрдүүлэлт </span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Далайн эрэг</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Буудал</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Өглөөний цай</span>
                </li>
              </ul>

              <div class="pricing">
                <span class="original-price">$3500</span>
                <span style="color: red"
                  >Тооцоо xийж байна. Удаxгүй нээлттэй болно</span
                >
              </div>

              <gradient-button
                class="orange-button"
                size="medium"
                :arrow="true"
                :full-width="true"
                to="/form-fill"
              >
                Бүртгүүлэx
              </gradient-button>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Visitor Pass -->
        <v-col cols="12" md="4">
          <v-card class="pricing-card visitor-card" elevation="0">
            <div class="early-bird-badge">
              <v-icon small color="white">mdi-ticket</v-icon>
              4- сар
            </div>

            <v-card-text class="card-content">
              <h3 class="pass-name">
                Global Education & Training Exhibition 2026 (GETEX)
              </h3>
              <h3 class="pass-name">Dubai</h3>
              <h4 style="color: #fb2bff">4-р сарын 15-17</h4>
              <ul class="features-list">
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Global Show Conference</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>INTERNATIONAL EDU TRAVEL Conference</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Global Games Show Conference</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Exhibition</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Entry Access</span>
                </li>
                <li class="feature-item">
                  <v-icon color="#10b981" small>mdi-check-circle</v-icon>
                  <span>Hotel</span>
                </li>
              </ul>

              <div class="pricing">
                <span class="original-price">$3200</span>
                <span style="color: red"
                  >Тооцоо xийж байна. Удаxгүй нээлттэй болно</span
                >
              </div>

              <gradient-button
                class="orange-button"
                size="medium"
                :arrow="true"
                :full-width="true"
                to="/form-fill"
              >
                Бүртгүүлэx
              </gradient-button>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import GradientButton from "./GradientButton.vue";

export default {
  name: "TicketPricing",
  components: {
    GradientButton,
  },
};
</script>

<style scoped>
.ticket-pricing-section {
  background: #ffffff;
  padding: 80px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: #030068;
  line-height: 1.2;
}

.pricing-cards {
  max-width: 1200px;
  margin: 0 auto;
}

.pricing-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px !important;
  overflow: visible;
  position: relative;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.pricing-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

.vip-card {
  background: linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%);
}

.delegate-card {
  background: linear-gradient(135deg, #f3e8ff 0%, #ede9fe 100%);
}

.visitor-card {
  background: linear-gradient(135deg, #f3e8ff 0%, #ede9fe 100%);
}

.early-bird-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: #5b21b6;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 1;
}

.card-content {
  padding: 40px 28px 28px !important;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.pass-name {
  font-size: 24px;
  font-weight: 700;
  color: #030068;
  margin: 0 0 20px 0;
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 0 0 28px 0;
  flex-grow: 1;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 0;
  font-size: 13px;
  line-height: 1.5;
}

.feature-item span {
  color: #000000;
  flex: 1;
}

.feature-item.excluded span {
  color: #9ca3af;
  text-decoration: line-through;
}

.pricing {
  text-align: left;
  margin-bottom: 20px;
  padding-top: 20px;
  border-top: 1px solid #dee2e6;
  margin-top: auto;
}

.original-price {
  display: block;
  font-size: 24px;
  color: red;
  text-decoration: line-through;
  margin-bottom: 4px;
}

.current-price {
  display: block;
  font-size: 36px;
  font-weight: 700;
  color: #000000;
  line-height: 1;
}

.free-price {
  font-size: 40px;
}

.orange-button {
  background: #ff8c00 !important;
}

.orange-button::before {
  background: #ff9500 !important;
}

/* Responsive Design */
@media (max-width: 960px) {
  .ticket-pricing-section {
    padding: 60px 0;
  }

  .section-title {
    font-size: 28px;
    line-height: 1.3;
  }

  .pricing-card {
    margin-bottom: 24px;
  }
}

@media (max-width: 600px) {
  .ticket-pricing-section {
    padding: 45px 0;
  }

  .section-header {
    margin-bottom: 40px;
    padding: 0 15px;
  }

  .section-title {
    font-size: 22px;
    line-height: 1.4;
  }

  .pass-name {
    font-size: 18px;
    line-height: 1.3;
  }

  .current-price {
    font-size: 28px;
  }

  .original-price {
    font-size: 20px;
  }

  .card-content {
    padding: 32px 18px 18px !important;
  }

  .feature-item {
    font-size: 12px;
    padding: 6px 0;
  }

  .early-bird-badge {
    top: 10px;
    right: 10px;
    padding: 5px 10px;
    font-size: 9px;
  }
}

@media (max-width: 400px) {
  .section-title {
    font-size: 20px;
  }

  .pass-name {
    font-size: 17px;
  }

  .current-price {
    font-size: 26px;
  }
}
</style>
